import React from 'react';
import { Phone, MessageCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section id="hero" className="relative pt-24 pb-16 sm:pt-32 sm:pb-24 bg-gradient-to-b from-green-50 to-white overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-100 rounded-full blur-3xl opacity-30 -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-green-100 rounded-full blur-3xl opacity-20 -z-10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <CheckCircle className="h-4 w-4" />
            Local & Reliable Service
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Professional Lawn Mowing &
            <span className="text-green-600"> Garden Maintenance</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Servicing Dandenong, Keysborough, Noble Park, Springvale and surrounding suburbs.
            Quality lawn care you can trust.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href="tel:0434600945" className="w-full sm:w-auto">
              <Button className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg font-semibold rounded-xl flex items-center justify-center gap-3 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105">
                <Phone className="h-6 w-6" />
                Call Now – 0434 600 945
              </Button>
            </a>
            <a href="sms:0434600945" className="w-full sm:w-auto">
              <Button className="w-full sm:w-auto bg-white hover:bg-gray-50 text-green-600 border-2 border-green-600 px-8 py-6 text-lg font-semibold rounded-xl flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-all transform hover:scale-105">
                <MessageCircle className="h-6 w-6" />
                Text Us 24/7
              </Button>
            </a>
          </div>

          {/* Trust Indicators */}
          <p className="text-sm text-gray-500 mb-4">24/7 messaging available – we'll get back to you as soon as possible</p>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mt-12">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-3">
                <CheckCircle className="h-6 w-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">Fast Response</h3>
              <p className="text-sm text-gray-600">Quick quotes and booking</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-3">
                <CheckCircle className="h-6 w-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">Affordable Pricing</h3>
              <p className="text-sm text-gray-600">Competitive local rates</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-3">
                <CheckCircle className="h-6 w-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">Quality Work</h3>
              <p className="text-sm text-gray-600">Professional results</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
